import { PageCardDisputeApiResponse } from './ApiResponse';
import { PageCardDispute } from './CardDispute';
import { PageCardDisputeEvidence } from './Evidence';
import { PageCardDisputeInformation } from './Information';
import { PageCardDisputeNew } from './Initiation/NewDispute';
import { PageCardDisputes } from './Overview';

export { PageCardDisputes } from './Overview';
export { PageCardDispute } from './CardDispute';
export { DisputeEvidenceComposer, type DisputeEvidenceComposerProps } from './Evidence/index';
export { DisputeDraftRepairPanel, type DisputeDraftRepairPanelProps } from './Initiation/DisputeDraftRepairPanel';

export const CARD_DISPUTES = {
  CardDisputes: PageCardDisputes,
  CardDisputeSection: PageCardDispute,
  CardDisputeInformation: PageCardDisputeInformation,
  CardDisputeEvidence: PageCardDisputeEvidence,
  CardDisputeApiResponse: PageCardDisputeApiResponse,
  CardDisputeNew: PageCardDisputeNew,
} as const;
